import React from "react";

export default function NotificationRequestsTab({ requests, loading, handleRequestAction, getAvatar }) {
  if (loading && requests.length === 0) {
    return null; // The parent component already handles the loading spinner
  }

  if (requests.length === 0 && !loading) {
    return (
      <div className="notif-empty">
        <div className="empty-icon">🚗</div>
        <p>No pending ride requests</p>
      </div>
    );
  }

  return (
    <>
      <style>
        {`
          .flex-badge-notif {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            background: #fffbeb;
            color: #d97706;
            border: 1px solid #fef3c7;
            padding: 4px 8px;
            border-radius: 6px;
            font-size: 11px;
            margin-top: 6px;
          }
          .req-info-block {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }
        `}
      </style>

      {requests.map((req) => (
        <div key={req._id} className="request-card">
          <div className="req-header">
            <img src={getAvatar(req.passenger)} alt="pax" className="req-avatar" />
            <div className="req-info-block">
              <h4 style={{ margin: "0 0 2px 0", fontSize: "14px" }}>{req.passenger?.name}</h4>
              <span className="req-seats" style={{ fontSize: "12px", color: "#64748b" }}>
                Wants <strong>{req.seatsRequested}</strong> seat{req.seatsRequested > 1 ? 's' : ''}
              </span>
              
              {/* ✅ THE FLEXIBLE ROUTE BADGE */}
              {req.flexibleRoute && (
                <div className="flex-badge-notif">
                  <span>⚠️</span>
                  <span>Flexible: <strong>{req.flexibleRoute}</strong></span>
                </div>
              )}
            </div>
          </div>

          {/* DRIVER'S MINI ROUTE */}
          <div className="req-route-mini" style={{ marginTop: "12px", background: "#f8fafc", padding: "8px", borderRadius: "8px", fontSize: "12px", color: "#475569" }}>
            <span>📍 {req.ride?.from}</span>
            <span className="arrow" style={{ margin: "0 6px" }}>→</span>
            <span>🏁 {req.ride?.to}</span>
          </div>

          {/* ACTIONS */}
          <div className="req-actions" style={{ marginTop: "12px", display: "flex", gap: "8px" }}>
            <button
              className="action-btn reject"
              style={{ flex: 1, padding: "8px", borderRadius: "8px", border: "1px solid #fee2e2", background: "#fff", color: "#ef4444", fontWeight: "600", cursor: "pointer" }}
              onClick={(e) => { e.stopPropagation(); handleRequestAction(req.ride?._id, req._id, "reject"); }}
            >
              Decline
            </button>
            <button
              className="action-btn accept"
              style={{ flex: 1, padding: "8px", borderRadius: "8px", border: "none", background: "#10b981", color: "#fff", fontWeight: "600", cursor: "pointer" }}
              onClick={(e) => { e.stopPropagation(); handleRequestAction(req.ride?._id, req._id, "accept"); }}
            >
              Accept
            </button>
          </div>
        </div>
      ))}
    </>
  );
}